module.exports = __webpack_public_path__ + "img/plan-personalizado.48a728b2.jpg";